export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./edit.vue?vue&type=template&id=4305166c"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/content/strings/edit.vue?vue&type=template&id=4305166c
// module id = sqck
// module chunks = 0